<template lang="pug">
span
  ModalPerfil
  ModalLogin
  modalEsqueciSenha
  ModalLogout(ref="modalLogout")
  ModalEdicaoCadastro
  .menu-lateral(:class="[!menuIsOpen && 'collapsed']")
    .menu-lateral__header
      .menu-lateral__header__logo
        img(src="@/assets/logo.png" alt="Logo")
        .menu-lateral__header__logo__nome(v-show="menuIsOpen") LinkDrive
        .colapse-menu(v-show="isLargeScreen" @click="toggleMenu" :class="[!menuIsOpen && 'rotate-left', menuIsOpen && 'rotate-right']")
          img(src="@/assets/icons/arrow.svg" alt="Colapse Menu")
      .menu-lateral__header__user
        .area-img-usuario(:class="[logado && 'logged-in']" @click="setModalPerfil(true)")
          img(:src="imagemUsuario" alt="User")
        .usuario(v-if="getUsuarioLogado" v-show="menuIsOpen")
          h3(@click="logado ? setModalPerfil(true) : false") {{ getUsuarioLogado.nome }}
          h5(@click="logado ? setModalPerfil(true) : false") {{ getUsuarioLogado.email }}
          button(@click="setModalPerfil(true)") Perfil
    .menu-lateral__menu
      .menu-lateral__menu__item(v-for="item in orderedMenu" :key="item.name" @click="navigateTo(item.linkTo)" :class="{ active: isActive(item.linkTo), disabled: item.isBloqued }")
        .menu-lateral__menu__item__icon
          img(:src="item.icon" alt="Icon")
        .menu-lateral__menu__item__text(:class="[!menuIsOpen && 'collapsed-text']") {{ item.text }}
    .sair
      .sair__text(:class="{ logado }" @click="!logado ? setModalLogin(true) : logOut(true)") {{ logado ? 'Sair' : 'Logar' }}
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ModalPerfil from '@/components/modais/ModalPerfil.vue'
import ModalLogin from '@/components/modais/LoginCadastro.vue'
import modalEsqueciSenha from '@/components/modais/EsqueciSenha.vue'
import ModalLogout from '@/components/modais/Logout.vue'
import ModalEdicaoCadastro from '@/components/modais/EdicaoCadastro.vue'

export default {
  name: 'MenuLateral',
  components: {
    ModalPerfil,
    ModalLogin,
    modalEsqueciSenha,
    ModalLogout,
    ModalEdicaoCadastro
  },
  data: () => ({
    menuIsOpen: true,
    user: JSON.parse(localStorage.getItem('user')),
    orderedMenu: [
      {
        name: 'anuncios',
        linkTo: 'Anúncios',
        icon: require('@/assets/icons/anuncios.svg'),
        text: 'Anúncios',
        isBloqued: false,
        params: {}
      },
      {
        name: 'meus anuncios',
        linkTo: 'Meus Anúncios',
        icon: require('@/assets/icons/meus_anuncios.svg'),
        text: 'Meus anúncios',
        isBloqued: !localStorage.getItem('_linkdrive'),
        params: {}
      },
      {
        name: 'componentes',
        linkTo: 'Componentes',
        icon: require('@/assets/icons/componentes.svg'),
        text: 'Componentes',
        isBloqued: true,
        params: {}
      },
      {
        name: 'arquivos',
        linkTo: 'Arquivos',
        icon: require('@/assets/icons/arquivos.svg'),
        text: 'Arquivos',
        isBloqued: false,
        params: {}
      },
      {
        name: 'pacotes',
        linkTo: 'Pacotes',
        icon: require('@/assets/icons/pacotes.svg'),
        text: 'Pacotes',
        isBloqued: false,
        params: {}
      },
      {
        name: 'forum',
        linkTo: 'Fórum',
        icon: require('@/assets/icons/forum.svg'),
        text: 'Fórum',
        isBloqued: true,
        params: {}
      }
    ]
  }),

  computed: {
    ...mapGetters({
      getUsuarioLogado: 'usuario/user'
    }),

    isLargeScreen() {
      return window.innerWidth >= 576;
    },
    logado() {
      if (localStorage.getItem('_linkdrive')) return true
      else return false
    },
    imagemUsuario() {
      if (this.getUsuarioLogado && this.getUsuarioLogado.path_imagem) return this.getUsuarioLogado.path_imagem
      else return require('@/assets/avatar.svg')
    },

  },

  watch: {
    isLargeScreen(newVal) {
      if (!newVal) {
        this.menuIsOpen = false;
      }
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Initial check
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    ...mapMutations({
      setModalPerfil: 'modais/setPerfil',
      setModalLogin: 'modais/setLogin',
      setModalLogout: 'modais/setLogout',
      setEdicaoInformacoes: 'modais/setEdicaoInformacoes',
    }),

    toggleMenu() {
      if (this.isLargeScreen) {
        this.menuIsOpen = !this.menuIsOpen;
      }
    },
    handleResize() {
      if (!this.isLargeScreen) {
        this.menuIsOpen = false;
      }
    },
    logOut() {
      this.$refs.modalLogout.sair()
    },
    navigateTo(link) {
      this.$router.push({ name: link }).catch(err => console.log(err));
    },
    isActive(link) {
      return this.$route.name === link;
    }
  }
}
</script>

<style lang="scss">
.menu-lateral {
  border-right: 1px solid rgba(50, 50, 50, .3);
  width: 250px;
  height: 100%;
  text-align: center;
  transition: all .5s;
  position: sticky;
  top: 0;
  z-index: 9;
  background: #000;
  max-width: 250px;
  min-width: 0;
  box-shadow: 1px 1px 25px 10px rgba(0, 0, 0, .6);

  .menu-lateral__header__logo {
    img {
      transition: all .6s;
      transform: rotate(0deg);
    }
  }

  &.collapsed {
    width: 90px;

    .menu-lateral__header__logo {
      img {
        transform: rotate(360deg);
      }
    }

    .menu-lateral__header__logo__nome,
    .menu-lateral__header__user .usuario {
      display: none;
    }


    .menu-lateral__header {
      .menu-lateral__header__logo {
        img {
          width: 60px;
          height: 60px;
        }
      }

      .menu-lateral__header__user {
        .area-img-usuario {
          width: 50px;
          height: 50px;

          img {
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .menu-lateral__menu {
      .menu-lateral__menu__item {
        flex-direction: column;

        .menu-lateral__menu__item__text {
          display: block;
          font-size: 11px;
          margin-left: 0;
          font-weight: 300;
          text-align: center;
        }
      }
    }

    .sair {
      .sair__text {
        width: 50px;
        font-size: 12px;
      }
    }
  }

  .menu-lateral__header {
    border-bottom: 1px solid #323232;

    .menu-lateral__header__logo {
      border-bottom: 1px solid #323232;
      cursor: pointer;
      padding: 10px 0;
      position: relative;

      img {
        width: 80px;
        height: 80px;
      }

      .menu-lateral__header__logo__nome {
        color: #fff;
        font-size: 1.5em;
        margin-top: -15px;
      }

      .colapse-menu {
        width: 20px;
        height: 20px;
        position: absolute;
        right: -10px;
        bottom: 5px;
        cursor: pointer;
        border: 1px solid #2b7ec0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: transform 0.3s ease;

        img {
          width: 18px;
          transition: all .3s;
          line-height: 0;
          filter: brightness(0) saturate(100%) invert(46%) sepia(35%) saturate(996%) hue-rotate(164deg) brightness(90%) contrast(94%);
          transition: transform 0.3s ease;
        }

        &.rotate-left img {
          transform: rotate(180deg);
        }

        &.rotate-right img {
          transform: rotate(0deg);
        }

        &:hover {
          transform: scale(1.25);
        }
      }
    }

    .menu-lateral__header__user {
      padding: 20px 10px;
      display: inline-flex;
      flex-direction: row;
      gap: 10px;

      .area-img-usuario {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin: 0 auto;
        position: relative;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }

        &::before {
          position: absolute;
          content: "";
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.5);
          background-image: url('@/assets/icons/edit.svg');
          background-repeat: no-repeat;
          background-position: center;
          opacity: 0;
          transition: opacity 0.3s ease, box-shadow 0.3s ease;
        }

        &.logged-in:hover::before {
          opacity: 1;
          box-shadow: 0 0 15px 1px rgba(255, 255, 255, .6);
        }
      }

      .usuario {

        h3,
        h5 {
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 150px;
        }

        h3 {
          color: #fff;
          font-size: 18px;
          margin: 0;
        }

        h5 {
          color: #ffffff69;
          font-size: 12px;
          font-weight: 400;
          margin: 0;
          margin-bottom: 10px;
        }

        button {
          color: #fff;
          font-size: 11px;
          margin: 0;
          width: 100%;
          border: none;
          padding: 5px 10px;
          border-radius: 5px;
          text-align: center !important;
          background: #383737;
          text-align: left;
          cursor: pointer;
        }
      }
    }
  }

  .menu-lateral__menu {
    .menu-lateral__menu__item {
      cursor: pointer;
      padding: 10px 15px;
      transition: all .3s;
      display: flex;
      align-items: center;
      margin-bottom: 2px;

      &:hover {
        background: rgba(255, 255, 255, .1);
      }

      .menu-lateral__menu__item__icon {
        line-height: 0;

        img {
          filter: brightness(0) saturate(100%) invert(46%) sepia(35%) saturate(996%) hue-rotate(164deg) brightness(90%) contrast(94%);
        }
      }

      .menu-lateral__menu__item__text {
        color: #fff;
        font-size: 14px;
        font-weight: 300;
        font-family: sans-serif, system-ui, ui-monospace, poppins;
        margin-left: 10px;
      }

      .menu-lateral__menu__item__text.collapsed-text {
        display: block;
        font-size: 12px;
        margin-left: 0;
        text-align: center;
      }

      &.disabled {
        pointer-events: none;
        opacity: 0.4;
      }
    }

    .menu-lateral__menu__item.active {
      background: rgba(255, 255, 255, .1);
    }
  }

  .sair {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);


    .sair__text {
      cursor: pointer;
      padding: 5px;
      transition: all .3s;
      width: 100px;
      font-size: 14px;
      border-radius: 30px;
      opacity: .7;
      color: #64b5f6;
      border: 1px solid #64b5f6;

      &:hover {
        color: #fff;
        background: rgba(100, 181, 246, 0.1);
        /* Soft blue background */
        opacity: 1;
      }

      &.logado {
        border: 1px solid #e57373;
        color: #e57373;

        &:hover {
          color: #fff;
          background: rgba(229, 115, 115, 0.1);
          opacity: 1;
        }
      }
    }
  }
}
</style>